import React, { useEffect, useState } from "react";
import { Button } from "@mhome/ui";
import {
  UnfoldLess,
  UnfoldMore,
  Curtains,
  CurtainsClosed,
  VerticalShades,
} from "@mui/icons-material";

const WindowOpenClose1Widget = ({ widget, onValueUpdate }) => {
  const [status, setStatus] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setStatus(
        currentValue === "" || currentValue === null ? "unknown" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!status) return "unknown";
    return status;
  };

  const isOpen = () => {
    return (
      status === "open" || status === "opening" || status === "partially open"
    );
  };

  const getStatusIcon = () => {
    switch (status) {
      case "open":
      case "opening":
        return <VerticalShades style={{ fontSize: "1.2rem" }} />;
      case "partially open":
        return <Curtains style={{ fontSize: "1.2rem" }} />;
      case "closed":
      case "closing":
        return <CurtainsClosed style={{ fontSize: "1.2rem" }} />;
      default:
        return <Curtains style={{ fontSize: "1.2rem" }} />;
    }
  };

  const handleCommand = (command) => {
    if (!widgetData) return;

    const updatedWidget = {
      ...widgetData.items.$w2,
      value: command,
    };
    onValueUpdate(updatedWidget);
  };

  return (
    <div
      className="w-full flex items-center relative gap-2"
      style={{ height: "40px" }}
    >
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleCommand("close");
        }}
        variant="contained"
        className="aspect-square min-w-0 p-0 flex-shrink-0 rounded-2xl transition-transform duration-200 active:scale-95 shadow-none"
        style={{ height: "40px" }}
      >
        <UnfoldLess
          style={{
            transform: "rotate(90deg)",
            fontSize: "1.2rem",
          }}
        />
      </Button>

      <div
        className="flex items-center justify-center bg-transparent border rounded-2xl px-1 flex-1 min-w-0 transition-colors duration-300 gap-2 overflow-hidden"
        style={{
          height: "40px",
          borderColor: isOpen() ? "hsl(var(--primary))" : "hsl(var(--border))",
        }}
      >
        {getStatusIcon()}
        <span className="text-[0.925rem] font-medium capitalize whitespace-nowrap overflow-hidden text-ellipsis min-w-0">
          {getStatusText()}
        </span>
      </div>

      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleCommand("open");
        }}
        variant="contained"
        className="aspect-square min-w-0 p-0 flex-shrink-0 rounded-2xl transition-transform duration-200 active:scale-95 shadow-none"
        style={{ height: "40px" }}
      >
        <UnfoldMore
          style={{
            transform: "rotate(90deg)",
            fontSize: "1.2rem",
          }}
        />
      </Button>
    </div>
  );
};

export default WindowOpenClose1Widget;
